import { createRouter, createWebHistory } from 'vue-router';
import { findTenant, firstLoad, isAdmin } from '@/session';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    { path: '/', redirect: '/tenants' },
    { path: '/tenants', name: 'tenants', component: () => import('@/pages/TenantsPage.vue') },
    {
      path: '/tenants/:slug',
      component: () => import('@/pages/tenant/TenantLayout.vue'),
      children: [
        { path: '', redirect: to => ({ name: 'tenant-keys', params: to.params }) },
        { path: 'keys', name: 'tenant-keys', component: () => import('@/pages/tenant/KeysTab.vue') },
        { path: 'webhooks', name: 'tenant-webhooks', component: () => import('@/pages/tenant/WebhooksTab.vue') },
        { path: 'events', name: 'tenant-events', component: () => import('@/pages/tenant/EventsTab.vue') },
        { path: 'send', name: 'tenant-send', component: () => import('@/pages/tenant/SendTab.vue') }
      ]
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('@/pages/TeamPage.vue'),
      meta: { adminOnly: true }
    },
    {
      path: '/unrouted',
      name: 'unrouted',
      component: () => import('@/pages/UnroutedPage.vue'),
      meta: { adminOnly: true }
    },
    { path: '/:pathMatch(.*)*', redirect: '/tenants' }
  ]
});

// The session (me, tenants, ...) is loaded by App.vue before the router ever renders a route (see
// the checking/anonymous/ready gate there), so isAdmin is always settled by the time a guard runs
// here — no need to await anything in-guard.
router.beforeEach(async to => {
  if (!to.meta.adminOnly) {
    return true;
  }

  // See firstLoad: on a deep link the session isn't known yet, and "not known" mustn't read as "not an Admin".
  await firstLoad;

  return isAdmin.value ? true : { name: 'tenants' };
});

router.afterEach(to => {
  const base = 'PostNoor Admin';
  if (to.name === 'tenants') {
    document.title = `Tenants · ${base}`;
  } else if (to.name === 'team') {
    document.title = `Team · ${base}`;
  } else if (to.name === 'unrouted') {
    document.title = `Unrouted · ${base}`;
  } else if (typeof to.params.slug === 'string') {
    const tenant = findTenant(to.params.slug);
    document.title = tenant ? `${tenant.name} · ${base}` : base;
  } else {
    document.title = base;
  }
});

export default router;
